<template>
  <div class="presentation-container page-content">    
    <div class="w-100 px-5 py-2" style="background-color: #3281bc;">
      <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-logo-white.png"  height="68" width="230" alt="Logo">
      <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/realshield-logo-blue.png"  height="68" width="230" alt="Logo">
      <img v-else src="../../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">
    </div>
    <div class="input-section">
      <div class="mb-4">      
        <div class="row justify-content-between align-items-center">
          <h4 class="col-md-8">
            Thank you for submitting your application to IBDPro (a division of OREP), we will review your application and send your Quote within three (3) business days. If you have any questions, please email <a target="_blank" href="mailto:service@ibdpro.com" style="font-size: 20px; color: #3d85c6;">service@ibdpro.com</a>
            or call <strong>866-840-8004</strong>.
          </h4>
          <div class="col-md-4">
            <img src="../../../public/assets/images/IBDPro-Call.png" class="img-call" style="width:225px" alt="Logo">
          </div>
        </div>
        </div>

      <div v-if="getApplicantType === 'Mercer'" class="mb-4 footer">
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            AMBA
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            PO Box 4050 NW 114th Street, Bldg 19
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Urbandale, IA  50322
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            1-866-795-9613
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            amba.service@amba.info
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits Advisors, LLC. In CA d/b/a
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits & Insurance Agency
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            CA Insurance License #0I96562
          </p>
        </div>
      </div>

      <div v-else-if="getApplicantType === 'Realshield'" class="mb-4 footer">
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            inspectors@OREP.org
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC. Calif. Lic. #0K99465
          </p>
        </div>
      </div>

      <div  v-else class="mb-4 footer">
        <p class="mt-3 strong">IBDPro – Insurance by Design (a Division of OREP)</p>
        <a href="https://www.IBDPRO.com" target="_blank">www.IBDPRO.com</a>
        <br />
        <a href="mailto:service@ibdpro.com" target="_blank">service@ibdpro.com</a>
        <p>Fax: (214) 217-2548</p>
        <p>Toll Free: (866) 840-8004</p>
        <p>TX Lic. #2113861 </p>
      </div>
    </div>
    


  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "ibdpro-insurance-agent-application-representation",
    computed: {
      insuranceAgentApplication() {
        return this.$store.state.insuranceAgentApplication.insuranceAgentApplication;
      },
      state() {
        return this.$store.state.insuranceAgentApplication;
      },
      errorMsg() {
        return this.$store.state.insuranceAgentApplication.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/ibdpro-insurance-agent-application-amba/' || this.insuranceAgentApplication.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/ibdpro-insurance-agent-application-realshield/' || this.insuranceAgentApplication.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }else {
          return 'OREP';
        }
      },
    },

    mounted() {
      this.validateBeforeSubmit();
      $('html, body').animate({
          scrollTop: $('.presentation-container').offset().top
      }, 500);
    },
  }
</script>

<style scoped>
  .container {
    background-color: white !important;
    padding-bottom: 30px;
  }
  .img-call {
    height: 170px;
    max-height: 170px;
  }
  p {
    margin: 5px 0;
  }
  .strong {
      font-weight: bold !important;
  }
  table td {
    padding: 0 5px !important;
  }
  table > tbody > tr > td:first-child {
    width: 35%
  }
  table > tbody > tr > td:last-child {
    width: 65%
  }


  .table-bordered td {
    vertical-align: top;
    border-right: 2px solid #dee2e6;
    border-left-width: 0;
    border-bottom-width: 0;
    border-top-width: 0;
  }
</style>
